import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const FingerprintIcon = (props: IconProps) => (
  <Icon viewBox="0 0 16 16" fill="none" title={t`Fingerprint`} {...props}>
    <Path
      d="M8 2.182c-1.818 0-3.273.945-4 2.182M8 2.182c1.818 0 3.273.945 4 2.182M4.364 12.364c-.582-1.091-.873-2.327-.873-3.637A4.51 4.51 0 0 1 8 4.218a4.51 4.51 0 0 1 4.51 4.51c0 1.309-.292 2.545-.874 3.636M5.818 10.91c-.363-.728-.545-1.455-.545-2.183A2.75 2.75 0 0 1 8 5.964a2.75 2.75 0 0 1 2.727 2.763c0 .728-.181 1.455-.545 2.182M8 8v2.91"
      stroke="currentColor"
      strokeWidth={0.91}
      strokeLinecap="round"
      fill="none"
    />
  </Icon>
);
